<template>
<!--  联系我们-->
  <div class="contactUs">
<!--    <div class="contactUsContent1">-->
<!--      <div class="contactUsContent_1">-->
<!--        <div class="contactUsContent_1_left">-->

<!--          <div class="contactUsContent_1_left1">-->
<!--            <div  class="contactUsContent_1_left1_1">-->
<!--              {{itemData.content.beijing.text1.content}}-->
<!--            </div>-->
<!--            <div  class="contactUsContent_1_left1_2">-->
<!--              {{itemData.content.beijing.text2.content}}-->
<!--            </div>-->
<!--            <div  class="contactUsContent_1_left1_3">-->
<!--              <div  class="contactUsContent_1_left1_4">{{itemData.content.beijing.text3.content}}</div>-->
<!--              <div  class="contactUsContent_1_left1_4">{{itemData.content.beijing.text4.content}}</div>-->
<!--              <div  class="contactUsContent_1_left1_4"> {{itemData.content.beijing.text5.content}}</div>-->
<!--              <div  class="contactUsContent_1_left1_4">{{itemData.content.beijing.text6.content}}</div>-->
<!--              <div  class="contactUsContent_1_left1_4"> {{itemData.content.beijing.text7.content}}</div>-->
<!--              <div  class="contactUsContent_1_left1_4"> {{itemData.content.beijing.text8.content}}</div>-->
<!--            </div>-->


<!--          </div>-->
<!--        </div>-->
<!--        <div class="contactUsContent_1_right">-->
<!--          <div class="contactUsContent_1_right_1">-->
<!--            <img :src="itemData.content.beijing.url.content" class="contactUsContent_1_right_img">-->
<!--          </div>-->
<!--        </div>-->
<!--      </div>-->
<!--    </div>-->
    <div class="contactUsContent1">
      <div class="contactUsContent_1">
        <div class="contactUsContent2_left">
          <div class="contactUsContent_1_right_1">
            <img :src="itemData.content.suzhou.url.content" class="contactUsContent_1_right_img">
          </div>
        </div>
        <div class="contactUsContent2_right">
          <div class="contactUsContent_1_left1">
            <div  class="contactUsContent_1_left1_1">
              {{itemData.content.suzhou.text1.content}}
            </div>
            <div  class="contactUsContent_1_left1_2">
              {{itemData.content.suzhou.text2.content}}
            </div>
            <div  class="contactUsContent_1_left1_3">
              <div  class="contactUsContent_1_left1_4">              {{itemData.content.suzhou.text3.content}}
              </div>
              <div  class="contactUsContent_1_left1_4">              {{itemData.content.suzhou.text4.content}}
              </div>
              <div  class="contactUsContent_1_left1_4">               {{itemData.content.suzhou.text5.content}}
              </div>
              <div  class="contactUsContent_1_left1_4">              {{itemData.content.suzhou.text6.content}}
              </div>
              <div  class="contactUsContent_1_left1_4">                {{itemData.content.suzhou.text7.content}}
              </div>
              <div  class="contactUsContent_1_left1_4">               {{itemData.content.suzhou.text8.content}}
              </div>
            </div>


          </div>
        </div>
      </div>
    </div>

    <div class="homeLeave">
      <div class="leave">
        <div class="homeLeave_left">
          <div class="homeLeave_left_1">
            {{itemData.content.homeLeave.text1.content}}
          </div>
          <div class="homeLeave_left_2">
            {{itemData.content.homeLeave.text2.content}}

          </div>
          <div class="homeLeave_left_3">
            <i class="el-icon-phone homeLeave_left_3_2"></i>
            <div class="homeLeave_left_3_1">
              {{itemData.content.homeLeave.text3.content}}

            </div>
          </div>
          <div class="homeLeave_left_4">
            <i class="el-icon-message homeLeave_left_3_2"></i>
            <div class="homeLeave_left_4_1">
              {{itemData.content.homeLeave.text4.content}}
            </div>
          </div>


        </div>
        <div class="homeLeave_right">
          <div class="homeLeave_right_1">
            <el-input v-model="homeLeaveData.userName" :placeholder="itemData.content.homeLeavePlace.text1"></el-input>
          </div>
          <div class="homeLeave_right_2">
            <el-input v-model="homeLeaveData.phone" :placeholder="itemData.content.homeLeavePlace.text2"></el-input>
            <el-input v-model="homeLeaveData.wechat" :placeholder="itemData.content.homeLeavePlace.text3" style="margin-left: 5px"></el-input>

          </div>
          <div class="homeLeave_right_3">
            <el-input
              type="textarea"
              :rows="5"
              :placeholder="itemData.content.homeLeavePlace.text4"
              v-model="homeLeaveData.message">
            </el-input>
          </div>

          <div class="homeLeave_right_4">
            <button class="homeLeave_right_4_1" @click="commit">{{itemData.content.homeLeavePlace.commit}}</button>
          </div>

        </div>
      </div>
    </div>
  </div>
</template>


<script>
import { Data } from './js/contactUs.js';
export default {
  name: "contactUs",
  data() {
    return {
      dataAll: Data,
      itemData: {},
      imageHeight: "596px",
      screenWidth: 0,
      menuIndex: "1",
      url:"http://116.62.38.250//image//nr/tp/gywm.jpg",
      homeLeaveData:{
      userName:"",
        phone:"",
        wechat:"",
        message:""
    }
    }
  },
  created() {
  },
  mounted() {
    let that = this;
    console.log(that.itemData);

    for(let index in that.dataAll){
      let itemData= that.dataAll[index];
      console.log(itemData.type);
      if(that.$parent.message == itemData.type){
        that.itemData = itemData;
        console.log(that.itemData);
        break;
      }
    }
    this.setWH();
    window.addEventListener('resize', this.setWH);


  },
  methods:{
    setWH() {
      let that = this;
      that.screenWidth = window.innerWidth;
      console.log("hh"+that.screenWidth);

      let hight = that.screenWidth /1440 *596;
      console.log("hhweee"+hight);
      that.imageHeight = hight + "px";
    },
    commit(){
      this.$axios
        .post('/acl/user/addUserMsg', {
          userName: this.homeLeaveData.userName,
          phone: this.homeLeaveData.phone,
          wechat:this.homeLeaveData.wechat,
          message:this.homeLeaveData.message
        })
        .then(successResponse => {
          console.log("结果："+successResponse)
          if (successResponse.data.code == "200") {

            this.$notify({
              title: '成功',
              message: '提交成功',
              type: 'success'
            });
            this.homeLeaveData.userName="";
            this.homeLeaveData.phone="";
            this.homeLeaveData.wechat="";
            this.homeLeaveData.message="";
          } else {
            this.$notify.error({
              title: '失败',
              message: '提交失败，请重新提交'
            });
          }
        })
        .catch(failResponse => {
          this.$notify.error({
            title: '失败',
            message: '提交失败，请重新提交'
          });
        })
    }
  }
  ,
  beforeDestroy() {
    window.removeEventListener('resize', this.setWH); // 移除监听器
  }
}
</script>

<style scoped>
.homeLeave_right_4_1{
  font-family: SourceHanSansCN;
  width: 100%;
  background: #014ED5;
  border-radius: 24px 24px 24px 24px;
  color: #FFFFFF;
  aspect-ratio: 560/48;
  border: none !important;
}
.homeLeave_right_4{
  margin-top: 16px;
  margin-left: 24px;
  margin-right: 24px;
}
.homeLeave_right_3{
  height: 120px;
  margin-top: 16px;
  margin-left: 24px;
  margin-right: 24px;
}
.homeLeave_right_2{
  height: 40px;
  display: flex;
  margin-top: 16px;
  margin-left: 24px;
  margin-right: 24px;
}
.homeLeave_right_1{
  height: 40px;
  margin-top: 24px;
  margin-left: 24px;
  margin-right: 24px;
}
.homeLeave_right{
  width: 53.5%;
  border-radius: 8px;
  /*box-shadow:*/
  /*  0 0 0 2px #a6a9ad, !* 外阴影，模拟边框 *!*/
  /*  0 2px 5px #FFFFFF;  !* 内阴影，增加元素立体感 *!*/
}
.homeLeave_left_3_2{
  font-size: 56px;
}
.homeLeave_left_4_1{
  font-family: Montserrat, Montserrat;
  font-weight: 700;
  font-size: 24px;
  color: #333333;
  line-height: 40px;
  text-align: left;
  font-style: normal;
  text-transform: none;
  margin-left: 3px;
}
.homeLeave_left_4{
  margin-top: 24px;
  display: flex;
  align-items: center;
}
.homeLeave_left_3_1{
  font-family: Montserrat, Montserrat;
  font-weight: 700;
  font-size: 24px;
  color: #333333;
  line-height: 40px;
  text-align: left;
  font-style: normal;
  text-transform: none;
  margin-left: 3px;

}
.homeLeave_left_3{
  display: flex;
  margin-top: 28px;
  align-items: center;

}
.homeLeave_left_2{
  font-family: SourceHanSansCN;
  font-weight: 400;
  font-size: 20px;
  color: #454545;
  line-height: 28px;
  text-align: left;
  font-style: normal;
  text-transform: none;
  margin-top: 24px;
}
.homeLeave_left_1{
  font-family: SourceHanSansCN;
  font-weight: 600;
  font-size: 40px;
  color: #333333;
  line-height: 56px;
  text-align: left;
  font-style: normal;
  text-transform: none;
}
.homeLeave_left{
  width: 46.5%;
  background-color: #FFFFFF;
}
.leave{
  width: 78%;
  display: flex;
}
.homeLeave{
  width: 100%;
  background-color: #FFFFFF;
  display: flex;
  justify-content: center;
  margin-top: 120px;
  margin-bottom: 120px;
}
.contactUsContent2_right{
  width: 57.14%;
  display: flex;
  justify-content: right;
}
.contactUsContent2_left{
  width: 42.86%;
}
.contactUsContent_1_right_img{
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
}
.contactUsContent_1_right_1{
  width: 100%;
  padding-top: 66.67%;
  position: relative;
}
.contactUsContent_1_right{
  width: 42.86%;
}
.contactUsContent_1_left1_4{
  font-family: SourceHanSansCN;
  font-weight: 400;
  font-size: 16px;
  color: #454545;
  line-height: 28px;
  text-align: justify;
  font-style: normal;
  text-transform: none;
}
.contactUsContent_1_left1_3{
  margin-top: 16px;
}
.contactUsContent_1_left1_2{
  font-family: SourceHanSansCN;
  font-weight: 600;
  font-size: 28px;
  color: #333333;
  line-height: 40px;
  text-align: left;
  font-style: normal;
  text-transform: none;
}

.contactUsContent_1_left1_1{

  font-family: SourceHanSansCN;
  font-weight: 600;
  font-size: 40px;
  color: #0A54D6;
  line-height: 56px;
  text-align: left;
  font-style: normal;
  text-transform: none;
  margin-top: 32px;
}
.contactUsContent_1_left1{
  width: 87.5%;
}
.contactUsContent_1_left{
  width: 57.14%;

}
.contactUsContent_1{
  width: 77.78%;
  display: flex;
}
.contactUsContent1{
  width: 100%;
  display: flex;
  justify-content: center;
  margin-top: 98px;
}
.contactUs{
  background: #FFFFFF;
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/contactUs.vue